import { UpgradeResult } from "./UpgradeResult";

export type SpentXPDetails = { [key: string]: UpgradeResult[] };

export type SpentXPDetailsModuleMap = {
  // TODO: ability to unspend the last item in one of the arrays
  [xpModuleKey: string]: SpentXPDetails[];
};

export const spentXPDetailsSample: SpentXPDetailsModuleMap = {
  mni: [
    {
      dex: [
        {
          upgradeType: "value",
          value: 13,
          resultUpgrade: { upgradeType: "value", value: 3 },
        },
      ],
    },
  ],
};
